import { Box } from "@mui/material"

export function ApplyTailoringToSchedulesScrollArea({ children }) {
    return (
        <Box
            data-cy="apply-tailoring-target-list"
            sx={{
                border: 1,
                borderColor: "divider",
                borderRadius: 1,
                maxHeight: { xs: 280, sm: 360 },
                overflowY: "auto",
                overflowX: "hidden",
            }}
        >
            {children}
        </Box>
    )
}
